import { BaseComponent } from "react-vextensions";
import { Row, Column, Button } from "react-vcomponents";
import { UpdateMapObject } from "Server/Commands/UpdateMapObject";
import { ModifyString } from "js-vextensions";
export class CompUIWrapper extends BaseComponent {
    render() {
        const { obj, compProp, children } = this.props;
        return (React.createElement(Column, { style: { border: "1px solid rgba(255,255,255,.3)" } },
            React.createElement(Row, { style: { backgroundColor: "rgba(255,255,255,.1)" } },
                ModifyString(compProp, m => [m.startLower_to_upper, m.lowerUpper_to_lowerSpaceLower]),
                React.createElement(Button, { ml: "auto", text: "X", onClick: () => {
                        new UpdateMapObject({ id: obj._key, updates: { [compProp]: null } }).Run();
                    } })),
            children));
    }
}
